import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { ChangeCursor } from "../../hlthtek-demo/components/MiscFunctions";
import axios from "axios";
import Navbar from "./Navbar";
import { toast } from "react-toastify";

function FacilityPartner({ updateList }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    watch,
  } = useForm();
  const [userType, setUserType] = useState(["", "Admin", "User"]);
  const [facilityList, setFacilityList] = useState([
    "HMIS",
    "EHR",
    "LIMS",
    "MedTech",
  ]);

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [states, setStates] = useState("");
  const [cities, setCities] = useState([]);
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_states/`, {
          headers: headers,
        })
        .then((res) => {
          setStates(res.data.state_list);
          console.log(res.data.state_list);
        });
    }
  }, [authToken]);

  const getStates = (stateName) => {
    console.log("stateName", stateName);
    var post_data = {
      state_name: stateName,
    };

    if (authToken !== "") {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_districts/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          console.log(res.data);
          setCities(res.data.district_list);
        });
    }
  };

  const history = useHistory();
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     sessionStorage.getItem("roleType") !== "admin"
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  useEffect(() => {
    if (sessionStorage.getItem("roleType") === "admin" && Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_partners_list/`, {
          headers: headers,
        })
        .then((res) => {
          console.log(res.data);
          //setFacilityList(res.data.services)
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken]);
  const onSubmit = (data, e) => {
    // console.log(getValues("user_type"))
    // if (getValues("user_type") === userType[0]) {
    //     setError("user_type", { type: 'validate', message: "User Type is required" }, { shouldFocus: true })
    //     return;
    // }
    e.preventDefault();
    console.log(data);
    if (Token()) {
      ChangeCursor();
      var post_data = {};
      post_data.company_name = data.company_name;
      post_data.phone = data.phone;
      post_data.email = data.email;
      post_data.address_line = data.address_line;
      post_data.city = data.city;
      post_data.pincode = data.pincode;
      post_data.state = data.state;
      post_data.registration_number = data.registration_number;
      post_data.primary_person = data.primary_person;
      post_data.primary_email = data.primary_email;
      post_data.primary_phone = data.primary_phone;
      post_data.secondary_person = data.secondary_person;
      post_data.secondary_email = data.secondary_email;
      post_data.secondary_phone = data.secondary_phone;
      post_data.partner_type = data.partner_type;
      post_data.activation_date = data.activation_date;
      post_data.created_date = new Date();
      post_data.active = data.active;
      console.log(data);
      console.log(post_data);
      console.log(headers);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}add_new_facility_partner/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status === "Success") {
            toast.success("Partner Added !!");
            updateList();
            ChangeCursor();
          } else if (res.data.status === "Failed") {
            toast.error(res.data.message);
            console.log(res);
            //ChangeCursor();
          } else {
            toast.error(res.data.message);
            ChangeCursor();
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
          ChangeCursor();
        });
    }
  };
  return (
    <div>
      {/* <Navbar /> */}
      <h1 style={{ textAlign: "center" }}>Add New Partner</h1>
      <div className="col-sm-12 col-md-12 col-lg-7" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50">
          <form
            className="contact-panel__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              {/* <div className="col-12">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className='form-control' placeholder='Enter Partner ID' name="partner_id" disabled value={""} {...register("partner_id")} />
                                </div>
                            </div> */}
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="company_name" className="required-label">
                  Partner Company Name
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Partner Company Name"
                    name="company_name"
                    {...register("company_name", {
                      required: "Partner Company Name is required.",
                      pattern: {
                        value: /^(?=.*[a-zA-Z])[a-zA-Z\s!@#$%^&*()]+$/,
                        message:
                          "Partner Company Name must contain alphabets and may include special characters",
                      },
                    })}
                  />
                  {errors.company_name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.company_name.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="phone" className="required-label">
                  Partner Phone no.
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Partner Phone no."
                    name="phone"
                    {...register("phone", {
                      required: "Partner Company Phone no. is required.",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Please enter a valid 10-digit phone number.",
                      },
                    })}
                  />
                  {errors.phone && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.phone.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="email" className="required-label">
                  Partner Email
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Partner Email"
                    name="email"
                    {...register("email", {
                      required: "Partner Company Email is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.email.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-12">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="password" className='form-control' placeholder='Enter Password' name="password" {...register("password", {
                                        required: "Password is required.",
                                    })} />
                                    {errors.password && (
                                        <p className="errorMsg">{errors.password.message}</p>
                                    )}
                                </div>
                            </div> */}
              <div className="col-12">
                <label htmlFor="address_line" className="required-label">
                  Partner Building/Street No./Flat No.
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Building/Street No./Flat No."
                    name="address_line"
                    {...register("address_line", {
                      required:
                        "Partner Building/Street No./Flat No. is required.",
                    })}
                  />
                  {errors.address_line && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.address_line.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className='form-control' placeholder='Enter City' name="city" {...register("city", {
                                        required: "Partner Company City is required.",
                                    })} />
                                    {errors.city && (
                                        <p className="errorMsg" style={{ color: "red" }}>{errors.city.message}</p>
                                    )}
                                </div>
                            </div> */}

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="state" className="required-label">
                  States
                </label>

                <select
                  className="form-control"
                  name="state"
                  {...register("state", {
                    required: "State is required.",
                  })}
                  onChange={(e) => {
                    // Call getStates here when state selection changes
                    getStates(e.target.value);
                  }}
                >
                  <option value="">Select State</option>
                  {states &&
                    states.map((state, index) => (
                      <option
                        key={index}
                        value={state.state_name.toLowerCase()}
                      >
                        {state.state_name}
                      </option>
                    ))}
                </select>
                {errors.state && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.state.message}
                  </p>
                )}
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="city" className="required-label">
                  City
                </label>

                <div className="form-group">
                  <select
                    className="form-control"
                    name="city" // Change "district" to "city" here
                    {...register("city", {
                      required: "City is required.",
                    })}
                  >
                    <option value="">Select City</option>
                    {cities.map((city, index) => (
                      <option
                        key={index}
                        value={city.district_name.toLowerCase()}
                      >
                        {city.district_name}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.city.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="pincode" className="required-label">
                  Pincode
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Pincode"
                    name="partner_pincode"
                    {...register("pincode", {
                      required: "Partner Company Pincode is required.",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Pin code must only contain numbers",
                      },
                    })}
                  />
                  {errors.pincode && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.pincode.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className='form-control' placeholder='Enter State' name="partner_state" {...register("state", {
                                        required: "Partner Company State is required.",
                                    })} />
                                    {errors.state && (
                                        <p className="errorMsg" style={{ color: "red" }}>{errors.state.message}</p>
                                    )}
                                </div>
                            </div> */}

              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className='form-control' placeholder='Enter Partner Address' name="partner_address" {...register("address", {
                                        required: "Partner Address is required.",
                                    })} />
                                    {errors.first_name && (
                                        <p className="errorMsg">{errors.first_name.message}</p>
                                    )}
                                </div>
                            </div> */}

              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className='form-control' placeholder='Enter Last Name' name="last_name" {...register("last_name", {
                                        required: "Last Name is required.",
                                    })} />
                                    {errors.last_name && (
                                        <p className="errorMsg">{errors.last_name.message}</p>
                                    )}
                                </div>
                            </div> */}
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <input type="date" className='form-control' placeholder='Enter DOB' name="dob" {...register("dob", {
                                        required: "DOB is required.",
                                    })} />
                                    {errors.dob && (
                                        <p className="errorMsg">{errors.dob.message}</p>
                                    )}
                                </div>
                            </div> */}
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input type="text" className='form-control' placeholder='Enter Address' name="address" {...register("address", {
                                        required: "Address is required.",
                                    })} />
                                    {errors.address && (
                                        <p className="errorMsg">{errors.address.message}</p>
                                    )}
                                </div>
                            </div> */}
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <label>User Type</label>
                                <div className="form-group">
                                    <i className="icon-user form-group-icon" ></i>
                                    <select className="form-control" name='user_type' {...register("user_type", {
                                        required: true,
                                    })}>
                                        {userType.map((item, index) => (
                                            <option value={item}>{item}</option>
                                        ))}
                                    </select>
                                    {errors.user_type && (
                                        <p className="errorMsg">{errors.user_type.message}</p>
                                    )}
                                </div>
                            </div> */}
              <div className="col-12">
                <label htmlFor="registration_number" className="required-label">
                  Company Registration No.
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Company Registration No."
                    name="registration_number"
                    {...register("registration_number", {
                      required: "Enter Company Registration No. is required.",
                    })}
                  />
                  {errors.registration_number && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.registration_number.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="primary_person" className="required-label">
                  Primary Contact Name{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Primary Contact Name"
                    name="primary_person"
                    {...register("primary_person", {
                      required: "Primary Contact Name is required.",
                      pattern: {
                        value: /^[a-zA-Z\s!@#$%^&*()]+$/,
                        message:
                          "Primary Contact Name must contain only alphabets and special characters",
                      },
                    })}
                  />
                  {errors.primary_person && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.primary_person.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="primary_phone" className="required-label">
                  Primary Contact Phone No.{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Primary Contact Phone No."
                    name="primary_phone"
                    {...register("primary_phone", {
                      required: "Primary Phone is required.",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Please enter a valid 10-digit phone number.",
                      },
                    })}
                  />
                  {errors.primary_phone && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.primary_phone.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="primary_email" className="required-label">
                  Primary Contact Email{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Primary Contact Email"
                    name="primary_email"
                    {...register("primary_email", {
                      required: "Primary Contact Email is required.",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.primary_email && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.primary_email.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="secondary_person" className="required-label">
                  Secondary Contact Name{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Secondary Contact Name"
                    name="secondary_person"
                    {...register("secondary_person", {
                      required: "Secondary Contact Name is required.",
                      pattern: {
                        value: /^[a-zA-Z\s!@#$%^&*()]+$/,
                        message:
                          "Primary Contact Name must contain only alphabets and special characters",
                      },
                    })}
                  />
                  {errors.secondary_person && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.secondary_person.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="secondary_phone" className="required-label">
                  Secondary Contact Phone No{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Secondary Contact Phone No."
                    name="secondary_phone"
                    {...register("secondary_phone", {
                      required: "Secondary Phone is required.",
                      pattern: {
                        value: /^\d{10}$/,
                        message: "Please enter a valid 10-digit phone number.",
                      },
                    })}
                  />
                  {errors.secondary_phone && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.secondary_phone.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <label htmlFor="secondary_email" className="required-label">
                  Secondary Contact Email{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Secondary Contact Email"
                    name="secondary_email"
                    {...register("secondary_email", {
                      required: "Secondary Contact Email is required.",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.secondary_email && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.secondary_email.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                                <label>Partner Type</label>
                                <div className="form-group">
                                    <i className="icon-user form-group-icon" ></i>
                                    <select
                                        className="form-control"
                                        name='partner_type'
                                        {...register("partner_type", {
                                            required: "Partner Type is required.",
                                            // validate: (value) => value === "-select-" && "Please select a valid partner type.",
                                        })}
                                    >
                                        {facilityList !== undefined && facilityList.length > 0 ?
                                            facilityList.map((item, index) => (
                                                <option key={index} value={item}>
                                                    {item}
                                                </option>
                                            ))
                                            :
                                            []
                                        }
                                    </select>
                                    {errors.partner_type && (
                                        <p className="errorMsg" style={{ color: "red" }}>{errors.partner_type.message}</p>
                                    )}
                                </div>
                            </div> */}

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="partnerType" className="required-label">
                  Partner Type{" "}
                </label>
                <div className="form-group">
                  <i className="icon-user form-group-icon"></i>
                  <select
                    className="form-control"
                    name="partner_type"
                    {...register("partner_type", {
                      required: "Partner Type is required.",
                    })}
                  >
                    {facilityList !== undefined && facilityList.length > 0 ? (
                      <>
                        {facilityList.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </>
                    ) : (
                      []
                    )}
                  </select>
                  {errors.partner_type && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.partner_type.message}
                    </p>
                  )}
                  {/* {watch('partner_type') === 'select user' && (
                                        <p className="errorMsg" style={{ color: "red" }}>Please select a valid partner type.</p>
                                    )} */}
                </div>
              </div>

              <div className="col-sm-6 col-md-6 col-lg-6">
                <label className="required-label">Activation Date </label>
                <div className="form-group form-group-date">
                  <i className="icon-calendar form-group-icon"></i>
                  <input
                    type="date"
                    className="form-control"
                    id="contact-date"
                    name="activation_date"
                    {...register("activation_date")}
                    required
                  />
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                {/* <label>Partner Type</label> */}

                <div className="form-group">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      placeholder="Active"
                      name="active"
                      {...register("active")}
                    />
                    <label
                      class="form-check-label required-label"
                      for="flexRadioDefault2"
                    >
                      Active
                    </label>
                  </div>
                  {errors.active && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.active.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Add Partner</span> <i className="icon-arrow-right"></i>
                </button>
                <div className="contact-result"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FacilityPartner;
